import request from '@/utils/request'
//自定义类目列表
export function categoryList(data) {
    return request({
        url: `/Goods/GetMemberCategoryList`,
        method: 'post',
        data
    })
}

//企业产品列表
export function productList(data) {
    return request({
        url: `/Goods/GetMobileMemberGoodList`,
        method: 'post',
        data
    })
}



//产品详情
export function productDetail(data) {
    return request({
        url: `/Goods/GetMobileGoodDetail`,
        method: 'post',
        data
    })
}

//转换
export function converPhotoBase64(data) {
    return request({
        url: `/Member/ConverPhotoBase64`,
        method: 'post',
        data
    })
}

export function memberGoodList(data) {
    return request({
        url: `/MemberPost/GetPostMemberGoodList`,
        method: 'post',
        data
    })
}


//产品列表
export function pList(data) {
    return request({
        url: `/Goods/GetMobileGoodList`,
        method: 'post',
        data
    })
}

//会员列表
export function mobileMemberList(data) {
    return request({
        url: `/Member/GetMobileMemberList`,
        method: 'post',
        data
    })
}

//文章列表
export function homeArticleList(data) {
    return request({
        url: `/Home/GetHomeArticleList`,
        method: 'post',
        data
    })
}

//视频列表
export function homeVideoList(data) {
    return request({
        url: `/Home/GetHomeVideoList`,
        method: 'post',
        data
    })
}